import { SvgIcon } from '@mui/material';

// Material Symbols Outlined at weight 200, the icon style of the 2026 brand guidelines
export const ArrowForwardIcon = (props) => (
  <SvgIcon viewBox="0 -960 960 960" {...props}>
    <path d="M683.15-460H200v-40h483.15L451.46-731.69 480-760l280 280-280 280-28.54-28.31L683.15-460Z" />
  </SvgIcon>
);
